import Helper from "./Helper";

class LinkHandler {
  constructor() {
    
    const links = Array.prototype.slice.call(document.querySelectorAll('.target-blank'));

    links.forEach(element => {
      element.setAttribute("target", "_blank");
    });

  }
}

export default LinkHandler;
